module.exports = __webpack_public_path__ + "static/media/adminpc.4bc07575.jpg";